import { render, staticRenderFns } from "./4mRiskTab.vue?vue&type=template&id=689d079e"
import script from "./4mRiskTab.vue?vue&type=script&lang=js"
export * from "./4mRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('689d079e')) {
      api.createRecord('689d079e', component.options)
    } else {
      api.reload('689d079e', component.options)
    }
    module.hot.accept("./4mRiskTab.vue?vue&type=template&id=689d079e", function () {
      api.rerender('689d079e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/risk/4mRiskTab.vue"
export default component.exports